import { useState, useEffect } from "react";

// Shared across TriageCenter.jsx (owns the toggle + this key), LeadTriageLayout.jsx,
// and Layout.jsx — all three read/write the same localStorage key so a refresh
// mid-presentation keeps every layer collapsed.
export const PRESENTATION_MODE_KEY = "ros.triage.presentationMode";

/**
 * Lead Triage Presentation Mode hides chrome across three components that
 * don't share a parent-child relationship (Layout's header/banners,
 * LeadTriageLayout's tab strip, TriageCenter's own summary/filter bar) —
 * so "is presentation mode on" is broadcast via a window event (fired by
 * TriageCenter, which owns the toggle) instead of prop-drilling.
 */
export function usePresentationChrome() {
  const [presentationMode, setPresentationMode] = useState(
    () => localStorage.getItem(PRESENTATION_MODE_KEY) === "true"
  );

  useEffect(() => {
    const onModeChange = (e) => setPresentationMode(!!e.detail?.enabled);
    window.addEventListener("ros:presentationMode", onModeChange);
    return () => window.removeEventListener("ros:presentationMode", onModeChange);
  }, []);

  return { presentationMode };
}
